import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './OnboardingSuccess.css';

const OnboardingSuccess = ({ registrationMessage, onContinue }) => {
  useEffect(() => {
    // Add entrance animation class
    const container = document.querySelector('.success-container');
    if (container) {
      container.classList.add('animate-in');
    }
  }, []);

  return (
    <div className="success-overlay">
      <Container fluid className="success-container">
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col xs={12} md={8} lg={6} xl={5}>
            <div className="success-card">
              <div className="success-icon">
                <span className="celebration-emoji">🎉</span>
              </div>

              <h1 className="success-title">
                Onboarding Completed Successfully!
              </h1>

              {/* <p className="success-message">
                {registrationMessage || 'Your account has been created and verified. You will be redirected shortly...'}
              </p> */}

              <div className="success-divider"></div>

              <p className="success-subtitle">
                Thank you for completing the onboarding process. Your account is now ready to use.
              </p>

              <div className="success-actions">
                <button
                  className="continue-button"
                  onClick={onContinue}
                >
                  Continue to Login
                </button>
              </div>

              <div className="success-decoration">
                <div className="floating-shape shape-1"></div>
                <div className="floating-shape shape-2"></div>
                <div className="floating-shape shape-3"></div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default OnboardingSuccess;
